export function CheckIdentity(name) {
  let Identity = JSON.parse(localStorage.getItem("Identity"));
  return Identity.find((e) => e.claimValue == name)?.isSelected;
}
